import {RecordForm} from '../forms/RecordForm';


import {useApplicationScreenshot} from '../hooks/useApplicationScreenshot.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";


export const AddPage = () => {

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = useApplicationScreenshot();

    return (
        <FormPageLayout
            title='New Application Screenshot'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as any} handleSubmit={createRecord} handleCancel={() => navigate('/application-screenshots')}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
